import logo from '../../../assets/logo.png'
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from '@/view/components/ui/input-otp'
import { REGEXP_ONLY_DIGITS } from 'input-otp'
import { Button } from '@/view/components/ui/button'
import { Spinner } from '@/view/components/ui/spinner'
import { useLoginController } from './useLoginController'

export const WhitelabelLogin = () => {
  const { code, handleAccess, setCode, isLoading, isValid, lenght } =
    useLoginController()

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center xl:flex-row xl:justify-start">
      <section className="flex w-full flex-col items-center  justify-center">
        <img className="w-64" src={logo} alt="logo" />
        <div className="mt-24 flex flex-col gap-8 text-black03">
          <h1 className="md:text-2l font-semibold lg:text-3xl">
            Código de cliente
          </h1>
          <h2>Digite o código único fornecido para acessar sua conta</h2>
          <InputOTP
            maxLength={lenght}
            value={code}
            onChange={(value) => setCode(value)}
            pattern={REGEXP_ONLY_DIGITS}
            className="w-full "
          >
            <InputOTPGroup className="w-full items-center justify-center gap-2 ">
              {new Array(lenght).fill(0).map((_, i) => (
                <InputOTPSlot
                  index={i}
                  key={i}
                  className="h-16 w-16 border text-3xl font-bold"
                />
              ))}
            </InputOTPGroup>
          </InputOTP>
          <Button
            onClick={() => handleAccess()}
            disabled={!isValid || isLoading}
          >
            {isLoading ? <Spinner className="text-white" /> : 'Acessar'}
          </Button>
        </div>
      </section>
    </div>
  )
}
